const cookies = require("browser-cookies");
export const getPersistedSelectedCity = () => {
    return Promise.resolve(cookies.get("cachedCity"));
};
export const setPersistedSelectedCity = (cachedCity) => {
    return Promise.resolve(cookies.set("cachedCity", cachedCity, { expires: 365 * 10 }));
};
